enum AppointmentStatus {
  CANCELED = 'CANCELED',
  COMPLETED = 'COMPLETED',
  CONFIRMED = 'CONFIRMED',
  DENIED = 'DENIED',
  PENDING = 'PENDING',
  RESCHEDULED = 'RESCHEDULED',
}

export { AppointmentStatus }
